import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { VideoCategoriesDataService, VideoCategoriesColumnsService } from '../../../services';
import { VideoCategory, VideoCategoriesResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-video-category-form',
  templateUrl: './video-category-form.component.html',
  styleUrls: ['./video-category-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class VideoCategoryFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public videoCategory: VideoCategory = {};
  public videoCategoryForm: FormGroup = new FormGroup({});
  public videoCategories: VideoCategory[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private videoCategoriesDataService: VideoCategoriesDataService,
    public videoCategoriesColumnsService: VideoCategoriesColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'VideoCategoryFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Video Category - Edit');
        this.getVideoCategory(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.videoCategory !== 'undefined') {
      this.videoCategory = this.dynamicDialogConfig.data.videoCategory;
    }
    if (typeof this.videoCategory.id === 'undefined' || this.videoCategory.id === null) {
      this.videoCategory.id = null;
    }
    this.getVideoCategories();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'VideoCategoryFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'VideoCategoryFormComponent');
  }

  getVideoCategory(id: number): void {
    this.isLoading = true;
    this.videoCategoriesDataService.getVideoCategory(id).subscribe((response: VideoCategory|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.videoCategory = response;
        this.prepareFrom();
      }
    });
  }

  getVideoCategories(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.videoCategories !== 'undefined' && this.dynamicDialogConfig.data.videoCategories.length > 0) {
      this.videoCategories = this.dynamicDialogConfig.data.videoCategories;
      return;
    }
    this.videoCategoriesDataService.getVideoCategories(this.parameters).subscribe((response: VideoCategoriesResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.videoCategories = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.videoCategoryForm = new FormGroup({
      id: new FormControl(this.videoCategory.id, []),
      name: new FormControl(this.videoCategory.name, [Validators.required, ]),
      nameAr: new FormControl(this.videoCategory.nameAr, []),
      nameFr: new FormControl(this.videoCategory.nameFr, []),
      slug: new FormControl(this.videoCategory.slug, [Validators.required, ]),
      slugAr: new FormControl(this.videoCategory.slugAr, []),
      slugFr: new FormControl(this.videoCategory.slugFr, []),
      picture: new FormControl(this.videoCategory.picture, []),
      description: new FormControl(this.videoCategory.description, [Validators.required, ]),
      descriptionAr: new FormControl(this.videoCategory.descriptionAr, []),
      descriptionFr: new FormControl(this.videoCategory.descriptionFr, []),
      parent: new FormControl((typeof this.videoCategory.parent === 'number') ? this.videoCategory.parent : this.videoCategory.parent?.id, []),
      videoType: new FormControl((typeof this.videoCategory.videoType === 'number') ? this.videoCategory.videoType : this.videoCategory.videoType?.id, [Validators.required, ]),
      ordering: new FormControl(this.videoCategory.ordering, []),
      status: new FormControl(this.videoCategory.status, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/video-categories']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.videoCategoryForm.controls).forEach((field: any) => {
        const control = this.videoCategoryForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.videoCategoryForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.videoCategory = this.videoCategoryForm.value;
    this.disableSubmit = true;
    console.log('videoCategory', this.videoCategory);
    if (typeof this.videoCategory.id !== 'undefined' && this.videoCategory.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.videoCategoriesDataService.updateVideoCategory(this.videoCategory).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('VIDEOCATEGORYUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('VIDEOCATEGORYNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.videoCategoriesDataService.addVideoCategory(this.videoCategory).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('VIDEOCATEGORYCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('VIDEOCATEGORYNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.videoCategoryForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'video-categories',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.videoCategoryForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-video-category-form',
  templateUrl: './video-category-form.component.html',
  styleUrls: ['./video-category-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogVideoCategoryFormComponent extends VideoCategoryFormComponent {
}

